import React from 'react'
import NextImage from 'next/image'

import { Text } from '@wartek-id/text'

import { useSETrackEvent } from 'app/ProfileRevampPage/hooks/useSETrackEvent'

import type { TProfileSocialMedia } from 'types/profile'

type TSocialMediaCardProps = {
  data: TProfileSocialMedia
}
const SocialMediaCard = ({ data }: TSocialMediaCardProps) => {
  const { SETrackClickSocialMedia } = useSETrackEvent()

  return (
    <div>
      <Text
        data-testid="profile-social-media-title"
        variant="subheading"
        className="mb-3"
      >
        MEDIA SOSIAL
      </Text>
      <div className="pb-4">
        {(Object.keys(data) ?? []).map((key) => {
          let url = data[key]

          if (!Boolean(url)) {
            return null
          }

          if (!/^https?:\/\//i.test(url)) {
            url = 'https://' + url
          }

          return (
            <a
              data-testid="profile-social-media-item"
              key={`social-media-${key}`}
              href={url}
              target="_blank"
              rel="noreferrer"
              className="flex items-center space-x-2 mb-4"
              onClick={() =>
                SETrackClickSocialMedia({
                  socialMedia: key as keyof TProfileSocialMedia,
                })
              }
            >
              <div className="p-1 pb-0 border border-subdued rounded-[4px]">
                <NextImage
                  src={`/icon/${key}.png`}
                  alt={key}
                  width="20px"
                  height="20px"
                  layout="fixed"
                />
              </div>
              <Text variant="body" className="underline truncate">
                {data[key]?.replace(/^https?:\/\//, '')}
              </Text>
            </a>
          )
        })}
      </div>
    </div>
  )
}

export default SocialMediaCard
